export const painPoints = [
  {
    emoji: '🧭',
    title: "You don't know where to start",
    desc: 'A client sends scattered messages, a vague brief, or a list of ideas. You need to turn that information into a clear project outline without overlooking important details.',
  },
  {
    emoji: '📋',
    title: 'You struggle to define project scope',
    desc: 'Deliverables, revisions, deadlines, responsibilities, and exclusions can become unclear. Without properly defining expectations, misunderstandings and additional work can become harder to manage.',
  },
  {
    emoji: '✍️',
    title: 'Every proposal takes too much time',
    desc: 'You keep rewriting similar sections, organizing information from scratch, and searching for the right words to explain what you offer.',
  },
  {
    emoji: '💎',
    title: 'You want to communicate your value more clearly',
    desc: "You know your service can help, but translating your expertise into a structured, client-focused proposal isn't always easy.",
  },
  {
    emoji: '🔍',
    title: 'You want to send more professional proposals',
    desc: 'You need a practical way to review your documents for missing details, vague language, inconsistent deliverables, and assumptions that should be clarified.',
  },
  {
    emoji: '🎯',
    title: 'You want a process you can repeat',
    desc: 'Instead of reinventing your workflow for every inquiry, you want a structured method that can be adapted to different clients, services, and projects.',
  },
];
